import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useClinicContext } from './useClinicContext';
import { getPrintPositions, updatePrintPositions } from '@/services/main/rezept/printPositionService';
import type { PrintPositionItem } from '@/services/main/rezept/printPositionService';

export const PRINT_POSITION_UPDATE_ERROR_MESSAGE = '更新ができませんでした。';

export function usePrintPosition(enabled = false) {
  const { tenant, clinicNumber } = useClinicContext();
  const queryClient = useQueryClient();

  const { data, isLoading, refetch } = useQuery<PrintPositionItem[]>({
    queryKey: ['print-positions', tenant, clinicNumber],
    queryFn: () => getPrintPositions(tenant ?? '', clinicNumber ?? ''),
    enabled: !!tenant && !!clinicNumber && enabled,
    staleTime: 0,
  });

  const { mutateAsync: save, isPending: isSaving } = useMutation({
    mutationFn: (positions: PrintPositionItem[]) =>
      updatePrintPositions(tenant ?? '', clinicNumber ?? '', positions),
    onSuccess: () => {
      // BD: "Automatically reload the レセプト発行 screen" after a successful update
      queryClient.invalidateQueries({ queryKey: ['rezept', 'list', tenant, clinicNumber] });
    },
  });

  return { positions: data ?? [], isLoading, isSaving, save, refetch };
}
